export default __webpack_public_path__ + "static/media/bringToFron.f334fab2.png";